function initMap() {
  if (typeof L === "undefined" || window.yogaMapInitalized === true) {
    return false;
  }

  var mapTitle = "YOGA LOFT Poznań";
  var mymap = L.map("inner-map").setView([52.4078894, 16.9073319], 18);

  L.tileLayer(
    "https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1Ijoib3B0aXhpbmUiLCJhIjoiY2p3NmtlM3NsMGtxdjRhcWthNW9xNGUwayJ9.gTLvesttMwAdbQm4ktddCw",
    {
      attribution:
        '<a href="https://www.mapbox.com/about/maps/" target="_blank">&copy; Mapbox</a> <a href="http://www.openstreetmap.org/about/" target="_blank">&copy; OpenStreetMap</a>',
      maxZoom: 17,
      id: "mapbox.streets"
    }
  ).addTo(mymap);

  var marker = L.marker([52.4078894, 16.9075319]).addTo(mymap);
  marker
    .bindPopup(
      "<strong>" +
        mapTitle +
        '</strong><br />ul. Gajowa 8/1<br />60-815 Poznań<br /><a href="tel:+48782087017">782 087 017</a>'
    )
    .openPopup();

  if (L !== undefined) {
    window.yogaMapInitalized = true;
  }
}

(function($) {
  if ("IntersectionObserver" in window) {
    var map = document.getElementById("inner-map");
    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (entry.intersectionRatio > 0) {
            initMap();
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.8, rootMargin: "0px 0px 100px 0px" }
    );
    observer.observe(map);
  } else {
    initMap();
  }
})(jQuery);
